import { Link } from '#router'
import { useFeatureFlag } from '@/hooks/use-feature-flag'
import { MARKETING_PAGES_FLAG } from '@/lib/marketing-content'

const footerSections = [
  {
    title: 'Links',
    links: [
      { href: '/how-it-works', label: 'How the Program Works' },
      { href: '/how-it-works#faq', label: 'FAQ' },
      { href: '/pricing', label: 'Pricing' },
    ],
  },
  {
    title: 'Contact',
    links: [{ href: '/about', label: 'About Us' }],
  },
  {
    title: 'Legal',
    links: [
      { href: '/terms', label: 'Terms of Service' },
      { href: '/privacy', label: 'Privacy Policy' },
      { href: '/security', label: 'Security' },
      { href: '/guidelines', label: 'Community Guidelines' },
    ],
  },
]

const baseLinks = [{ href: '/guidelines', label: 'Community Guidelines' }]

export default function Footer() {
  const flag = useFeatureFlag(MARKETING_PAGES_FLAG)
  const showSections = flag.isLoaded && flag.enabled

  return (
    <footer className="container mx-auto mt-auto border-t">
      <div className="text-muted-foreground flex flex-col gap-8 p-4 py-6 text-xs md:flex-row md:items-end md:justify-between">
        <div className="flex flex-col items-start gap-1">
          {!showSections && (
            <nav className="mb-3 flex flex-wrap gap-x-4 gap-y-1">
              {baseLinks.map(({ href, label }) => (
                <Link key={href} href={href} className="hover:text-foreground">
                  {label}
                </Link>
              ))}
            </nav>
          )}
          <div>
            Made with <span className="text-pink-500">♥</span> by Mike Mroczka
          </div>
          <div>© {new Date().getFullYear()} All rights reserved</div>
        </div>
        {showSections && (
          <nav
            aria-label="Footer"
            className="grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-16"
          >
            {footerSections.map(({ title, links }) => (
              <div key={title} className="flex flex-col gap-1.5">
                <h3 className="text-foreground font-semibold">{title}</h3>
                {links.map(({ href, label }) => (
                  <Link
                    key={href}
                    href={href}
                    className="hover:text-foreground"
                  >
                    {label}
                  </Link>
                ))}
              </div>
            ))}
          </nav>
        )}
      </div>
    </footer>
  )
}
